// extracted by mini-css-extract-plugin
export default {"root":"KeyFeatures__root--jVfU0","subtitle":"KeyFeatures__subtitle--x_w9d","features":"KeyFeatures__features--oDMXy"};